import React from 'react';
import '../styles/ModalAccionesPago.css';

const ModalAccionesPago = ({ 
  mostrar, 
  onCerrar, 
  pagoInfo, 
  onImprimirRecibo, 
  onEnviarWhatsApp 
}) => {
  if (!mostrar) return null;

  return (
    <div className="modal-overlay-acciones" onClick={onCerrar}>
      <div className="modal-acciones-pago" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-acciones">
          <div className="icono-exito">
            ✅
          </div>
          <h2>¡Pago Registrado Exitosamente!</h2>
          <button className="btn-cerrar-modal" onClick={onCerrar}>
            ✖
          </button>
        </div>

        {pagoInfo && (
          <div className="pago-info-detalle">
            <div className="info-row">
              <span className="label">Cliente:</span>
              <span className="valor">{pagoInfo.nombreCliente}</span>
            </div>
            <div className="info-row">
              <span className="label">Préstamo ID:</span>
              <span className="valor">#{pagoInfo.prestamoId}</span>
            </div>
            <div className="info-row">
              <span className="label">Monto Pagado:</span>
              <span className="valor destacado">${pagoInfo.montoPagado?.toFixed(2)}</span>
            </div>
            {pagoInfo.cuotasPagadas && (
              <div className="info-row">
                <span className="label">Cuotas Pagadas:</span>
                <span className="valor">{pagoInfo.cuotasPagadas} / {pagoInfo.totalCuotas}</span>
              </div>
            )}
          </div>
        )}

        <div className="acciones-container">
          <h3>¿Qué desea hacer ahora?</h3>
          
          <div className="botones-acciones">
            <button 
              className="btn-accion btn-imprimir"
              onClick={() => {
                onImprimirRecibo();
                onCerrar();
              }}
            >
              <span className="icono">🖨️</span>
              <span className="texto">Imprimir Recibo</span>
            </button>

            <button 
              className="btn-accion btn-whatsapp"
              onClick={() => {
                onEnviarWhatsApp();
                onCerrar();
              }}
            >
              <span className="icono">📱</span>
              <span className="texto">Enviar por WhatsApp</span>
            </button>

            <button 
              className="btn-accion btn-ambos"
              onClick={() => {
                onImprimirRecibo();
                onEnviarWhatsApp();
                onCerrar();
              }}
            >
              <span className="icono">🖨️📱</span>
              <span className="texto">Ambas Opciones</span>
            </button>
          </div>

          <button 
            className="btn-accion btn-cerrar-simple"
            onClick={onCerrar}
          >
            Cerrar (solo guardar)
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalAccionesPago;

